import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-datepicker', 'selectDate', 'Izvēlēties datumu');
Labels.set('ui-datepicker', 'selectedDate', 'Atlasītais datums');
Labels.set('ui-datepicker', 'close', 'Aizvērt');
Labels.set('ui-datepicker', 'clear', 'Notīrīt ievadi');
Labels.set(
    'ui-datepicker',
    'invalidFormatHint',
    'Datums jānorāda formātā dd.mm.gggg., piemēram, 24.12.2026'
);
